import { createStyles } from '@mui/styles';
import Colors from '../../layout/theme/utils/colors';
import { NextTheme } from '../../layout/theme-next/provider';

export default (theme: NextTheme) =>
  createStyles({
    container: {
      display: 'inline-block',
      '& .MuiButton-root': {
        padding: theme.spacing(1.31, 2.5),
        fontFamily: 'Sora',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 12,
        lineHeight: '15px',
        backgroundColor: Colors.white,
        color: Colors.navy,
        borderRadius: 100,
        minWidth: 72,
      },
    },
  });
